import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import App from './App';
import GlobalStyles from './globalStyles/GlobalStyles';

import { ConfigProvider, MsalConfig } from 'config';

import generateTheme from './theme';
import { ToastProvider } from 'toast';
import { AuthProvider } from 'auth';
import ErrorBoundary from 'containers/ErrorBoundary';
import 'utils/fetchInterceptor';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { DataProvider } from 'context/DataContext';

const theme = generateTheme();
export const msalInstance = new PublicClientApplication(MsalConfig);

ReactDOM.render(
  <ErrorBoundary>
    <Router>
      <ConfigProvider>
        <ThemeProvider theme={theme}>
          <MsalProvider instance={msalInstance}>
            <ToastProvider>
              <GlobalStyles />
              <AuthProvider>
                <DataProvider>
                  <App />
                </DataProvider>
              </AuthProvider>
            </ToastProvider>
          </MsalProvider>
        </ThemeProvider>
      </ConfigProvider>
    </Router>
  </ErrorBoundary>,
  document.getElementById('root')
);
